import React, { useState, useEffect } from 'react';
import api from '../api';
import { ensureGuid } from '../utils/id';
import { validateItem, hasErrors } from '../utils/validation';

function Items() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ id: '', name: '', createdDatetime: '' });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  const [attempted, setAttempted] = useState(false);

  const errors = validateItem(form);
  const isValid = !hasErrors(errors);

  async function load() {
    setLoading(true);
    setError(null);
    setMessage('');
    try{
      const data = await api.list('items');
      setItems(Array.isArray(data) ? data : []);
    }catch(e){
      console.error('load items', e);
      setError(e.message || String(e));
      setItems([]);
    }finally{
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  async function save() {
    if (!isValid) { setAttempted(true); return; }
    setSaving(true);
    setError(null);
    setMessage('');
    try {
      // 只在createdDatetime有值且合法时才传递
      const payload = { ...form, id: ensureGuid(form.id), tableId: 'Item' };
      if (!payload.createdDatetime || !payload.createdDatetime.trim()) {
        delete payload.createdDatetime;
      }
      if (form.id) await api.update('items', form.id, payload);
      else await api.create('items', payload);
      await load();
      setForm({ id: '', name: '', createdDatetime: '' });
      setMessage('保存成功');
      setAttempted(false);
    } catch (e) { console.error(e); setError(e.message || String(e)); }
    finally { setSaving(false); }
  }

  function edit(it) { setForm({
    id: it.id || '',
    name: it.name || '',
    createdDatetime: it.createdDatetime || ''
  }); }

  async function removeItem(id) { try { await api.remove('items', id); await load(); } catch(e){console.error(e);} }
  async function confirmRemove(id){ if(window.confirm('Delete this item?')) await removeItem(id); }

  return (
    <div className="page">
      <aside className="card">
        <h3>商品</h3>
        {error && <div className="alert error">{error}</div>}
        {message && <div className="alert info">{message}</div>}
        <div className="form-row">
          <label>名称</label>
          <input className={attempted && errors.name ? 'invalid' : ''} value={form.name} onChange={e=>setForm({...form,name:e.target.value})} />
          {attempted && errors.name && <div className="field-error">{errors.name}</div>}
        </div>
        {/* 数量字段已移除 */}
        {/* 创建时间字段已隐藏 */}
        <div style={{display:'flex',gap:8}}>
          <button className="btn" onClick={save} disabled={saving || loading}>{saving? '保存中...' : '保存'}</button>
          <button className="btn secondary" onClick={()=>{ setForm({ id: '', name: '', quantity: 0, createdDatetime: '' }); setMessage(''); setError(null); setAttempted(false); }}>重置</button>
        </div>
      </aside>
      <section className="card list" style={{overflowX:'auto'}}>
        <h3>商品列表</h3>
        {loading ? <div>Loading...</div> : (
        <table style={{minWidth:600}}>
          <thead><tr><th>名称</th><th></th></tr></thead>
          <tbody>
            {items.map(it=> (
              <tr key={it.id}>
                <td>{it.name}</td>
                <td className="actions">
                  <button className="btn ghost" onClick={()=>edit(it)}>编辑</button>
                  <button className="btn secondary" onClick={()=>confirmRemove(it.id)}>删除</button>
                </td>
              </tr>
            ))}
            {items.length===0 && <tr><td colSpan="2">暂无商品</td></tr>}
          </tbody>
        </table>)}
      </section>
    </div>
  );
}

export default Items;
